
import { useState } from 'react';

const benefits = [
  {
    icon: 'ri-rocket-line',
    title: 'Crescita Professionale',
    desc: 'Percorsi di carriera strutturati e opportunità di formazione continua per sviluppare le tue competenze.',
  },
  {
    icon: 'ri-team-line',
    title: 'Team di Eccellenza',
    desc: 'Lavora con professionisti HR di alto livello in un ambiente stimolante, collaborativo e orientato ai risultati.',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Benessere & Equilibrio',
    desc: 'Flessibilità lavorativa, welfare aziendale e attenzione al benessere delle persone sono al centro della nostra cultura.',
  },
  {
    icon: 'ri-trophy-line',
    title: 'Riconoscimento del Merito',
    desc: 'Premi, bonus e riconoscimenti concreti per chi porta valore reale all\'azienda e ai nostri clienti.',
  },
  {
    icon: 'ri-building-line',
    title: 'Clienti di Rilievo',
    desc: 'Collabora con aziende leader in diversi settori, ampliando la tua rete professionale e il tuo know-how.',
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Innovazione Continua',
    desc: 'Un ambiente che valorizza le idee nuove e incoraggia l\'iniziativa personale per migliorare processi e risultati.',
  },
];

export default function WorkWithUs() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const [fileName, setFileName] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const textarea = form.querySelector('textarea[name="messaggio"]') as HTMLTextAreaElement;
    if (textarea && textarea.value.length > 500) return;

    setLoading(true);
    const data = new FormData(form);
    const params = new URLSearchParams();
    data.forEach((value, key) => {
      if (key !== 'curriculum') {
        params.append(key, value as string);
      }
    });
    // curriculum non raccoglibile, segnalato come non raccoglibile
    if (fileName) {
      params.append('curriculum', 'Allegato: ' + fileName + ' (non raccoglibile)');
    }

    try {
      await fetch('https://readdy.ai/api/form/d6ipbhpbfjp31emakacg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="lavora-con-noi" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full mb-4" style={{background:'rgba(30,58,95,0.08)', color:'#1E3A5F'}}>
            Unisciti a Noi
          </span>
          <h2 className="text-5xl font-bold text-gray-900 mb-5" style={{fontFamily:'Inter, sans-serif'}}>
            Lavora con <span style={{color:'#B8860B'}}>PM Resources</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Siamo sempre alla ricerca di talenti appassionati di HR, selezione e consulenza. Se vuoi fare la differenza nel mondo del lavoro, questo è il posto giusto per te.
          </p>
        </div>

        {/* Benefits grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-20">
          {benefits.map((b) => (
            <div
              key={b.title}
              className="group bg-gray-50 rounded-2xl p-7 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border border-gray-100"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl mb-4 transition-all duration-300 group-hover:scale-110" style={{background:'rgba(30,58,95,0.1)'}}>
                <i className={`${b.icon} text-2xl`} style={{color:'#1E3A5F'}}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{b.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>

        {/* Form + image */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">

          {/* Left: image + quote */}
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/242c958d95f4ed923fe05cfd29a30eb7.jpg"
              alt="Lavora con PM Resources"
              className="w-full h-96 object-cover object-top rounded-3xl shadow-xl"
            />
            <div className="absolute -bottom-6 -right-4 bg-white rounded-2xl shadow-xl p-6 max-w-xs border border-gray-100">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full" style={{background:'#1E3A5F'}}>
                  <i className="ri-double-quotes-l text-white text-lg"></i>
                </div>
                <span className="text-sm font-bold text-gray-900">Perché sceglierci?</span>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed italic">
                "In PM Resources ogni persona è valorizzata. Cresciamo insieme ai nostri collaboratori, giorno dopo giorno."
              </p>
              <p className="text-xs font-semibold mt-3" style={{color:'#B8860B'}}>— Il Team PM Resources</p>
            </div>
          </div>

          {/* Right: form */}
          <div className="bg-gray-50 rounded-3xl p-8 border border-gray-100 shadow-sm">
            <h3 className="text-2xl font-bold text-gray-900 mb-2">Invia la tua candidatura</h3>
            <p className="text-sm text-gray-500 mb-7">Compila il form e allega il tuo CV. Ti contatteremo al più presto!</p>

            {submitted ? (
              <div className="flex flex-col items-center justify-center py-16 text-center">
                <div className="w-16 h-16 flex items-center justify-center rounded-full mb-4" style={{background:'rgba(30,58,95,0.1)'}}>
                  <i className="ri-check-line text-3xl" style={{color:'#1E3A5F'}}></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-2">Candidatura inviata!</h4>
                <p className="text-sm text-gray-600">Grazie per il tuo interesse. Ti contatteremo presto.</p>
              </div>
            ) : (
              <form
                data-readdy-form
                id="form-lavora-con-noi"
                onSubmit={handleSubmit}
                className="space-y-4"
              >
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1">Nome *</label>
                    <input
                      name="nome"
                      type="text"
                      required
                      placeholder="Mario"
                      className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white text-sm focus:outline-none focus:ring-2 focus:border-transparent transition-all"
                      style={{'--tw-ring-color':'#1E3A5F'} as React.CSSProperties}
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1">Cognome *</label>
                    <input
                      name="cognome"
                      type="text"
                      required
                      placeholder="Rossi"
                      className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white text-sm focus:outline-none focus:ring-2 focus:border-transparent transition-all"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1">Email *</label>
                  <input
                    name="email"
                    type="email"
                    required
                    placeholder="mario.rossi@email.com"
                    className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white text-sm focus:outline-none focus:ring-2 focus:border-transparent transition-all"
                  />
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1">Telefono</label>
                  <input
                    name="telefono"
                    type="tel"
                    placeholder="+39 333 1234567"
                    className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white text-sm focus:outline-none focus:ring-2 focus:border-transparent transition-all"
                  />
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1">Ruolo di interesse *</label>
                  <select
                    name="ruolo"
                    required
                    className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white text-sm focus:outline-none focus:ring-2 focus:border-transparent transition-all cursor-pointer"
                  >
                    <option value="">Seleziona un ruolo...</option>
                    <option value="Recruiter">Recruiter</option>
                    <option value="HR Consultant">HR Consultant</option>
                    <option value="Account Manager">Account Manager</option>
                    <option value="HR Business Partner">HR Business Partner</option>
                    <option value="Formatore">Formatore</option>
                    <option value="Candidatura Spontanea">Candidatura Spontanea</option>
                  </select>
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1">
                    Presentati brevemente *
                    <span className="ml-2 font-normal text-gray-400">({charCount}/500)</span>
                  </label>
                  <textarea
                    name="messaggio"
                    required
                    rows={4}
                    maxLength={500}
                    placeholder="Raccontaci chi sei, la tua esperienza e perché vuoi unirti a PM Resources..."
                    onChange={(e) => setCharCount(e.target.value.length)}
                    className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white text-sm focus:outline-none focus:ring-2 focus:border-transparent transition-all resize-none"
                  />
                  {charCount >= 500 && (
                    <p className="text-xs text-red-500 mt-1">Hai raggiunto il limite di 500 caratteri.</p>
                  )}
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1">Allega CV (PDF, DOC)</label>
                  <label className="flex items-center gap-3 w-full px-4 py-3 rounded-xl border border-dashed border-gray-300 bg-white cursor-pointer hover:border-gray-400 transition-all">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg" style={{background:'rgba(30,58,95,0.08)'}}>
                      <i className="ri-upload-2-line text-base" style={{color:'#1E3A5F'}}></i>
                    </div>
                    <span className="text-sm text-gray-500 truncate">
                      {fileName ? fileName : 'Clicca per caricare il tuo CV'}
                    </span>
                    <input
                      name="curriculum"
                      type="file"
                      accept=".pdf,.doc,.docx"
                      className="hidden"
                      onChange={(e) => setFileName(e.target.files?.[0]?.name || null)}
                    />
                  </label>
                  <p className="text-xs text-gray-400 mt-1">Nota: il file verrà registrato come allegato non raccoglibile.</p>
                </div>

                <button
                  type="submit"
                  disabled={loading || charCount > 500}
                  className="w-full py-4 text-white text-sm font-semibold rounded-xl hover:opacity-90 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2 disabled:opacity-60"
                  style={{background:'#1E3A5F'}}
                >
                  {loading ? (
                    <><i className="ri-loader-4-line animate-spin text-base"></i> Invio in corso...</>
                  ) : (
                    <><i className="ri-send-plane-line text-base"></i> Invia Candidatura</>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
